// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2qZLN","dragIcon":"Choice_dragIcon__1Y00p","left":"Choice_left__2tLYv","input":"Choice_input__3rVnV"};